export default {
  data() {
    return {
      editCustomField: {},
      customFieldIsLoading: {},
      customFieldValue: {},
      customFieldSelectOptions: {},
      datetimeFormat: {
        stringify: (date) => {
          return date
            ? this.$moment(date).tz(this.teams[this.$route.params.team].account.timezone).format("L HH:mm")
            : null;
        },
        parse: (value) => {
          return value
            ? this.$moment(value, "L HH:mm").tz(this.teams[this.$route.params.team].account.timezone).toDate()
            : null;
        },
      },
    };
  },
  methods: {
    setEditableCustomFields(customFields, obj) {
      let current = JSON.parse(JSON.stringify(obj));
      Object.keys(customFields).forEach((key) => {
        if (!customFields[key].readonly) {
          if (customFields[key].type === "select" || customFields[key].type === "multiselect") {
            const options = [];
            let label;
            customFields[key].config.options.forEach((option) => {
              option.label[this.teams[this.$route.params.team].account.locale]
                ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                : (label = option.label.default);
              options.push({ label: label, value: option.value });
              if (customFields[key].type === "select") {
                if (current.custom[key] && current.custom[key][0] === option.value) {
                  this.$set(this.customFieldValue, key, {
                    label: label,
                    value: option.value,
                  });
                }
              } else if (customFields[key].type === "multiselect") {
                if (!Array.isArray(this.customFieldValue[key])) {
                  this.$set(this.customFieldValue, key, []);
                }
                if (current.custom[key]) {
                  current.custom[key].forEach((o) => {
                    if (o === option.value) {
                      this.customFieldValue[key].push({
                        label: label,
                        value: option.value,
                      });
                    }
                  });
                }
              }
            });
            this.$set(this.customFieldSelectOptions, key, options);
          } else {
            if (customFields[key].type === "datetime") {
              current.custom[key] = this.$moment(current.custom[key])
                .tz(this.teams[this.$route.params.team].account.timezone)
                .toDate();
            }
            this.$set(this.customFieldValue, key, current.custom[key]);
          }
          this.$set(this.editCustomField, key, false);
          this.$set(this.customFieldIsLoading, key, false);
        }
      });
    },
    getCustomFieldTitle(customField) {
      return this.$h.getLanguageValue(customField.title);
    },
    getCustomFieldPlaceholder(customField) {
      return this.$h.getLanguageValue(customField.placeholder);
    },
    getCustomFieldValue(customField, index, current) {
      const type = customField.type;
      let value;
      switch (type) {
        case "datetime": {
          value = this.$h.formatDate(current.custom[index], this.teams[this.$route.params.team].account.timezone);
          break;
        }
        case "select": {
          const options = customField.config.options;
          let option = null;
          if (current.custom[index] !== null && current.custom[index].length) {
            for (const v in current.custom[index]) {
              option = options.find((o) => {
                return o.value === current.custom[index][v];
              });
            }
          }
          if (option) {
            value = this.$h.getLanguageValue(option.label);
          } else {
            value = "";
          }
          break;
        }
        case "multiselect": {
          const options = customField.config.options;
          if (current.custom[index] !== null && current.custom[index].length) {
            value = "<ul>";
            for (const va in current.custom[index]) {
              const option = options.find((o) => {
                return o.value === current.custom[index][va];
              });
              if (option) {
                if (!value) {
                  value = "<li>" + this.$h.getLanguageValue(option.label) + "</li>";
                } else {
                  value = value + "<li>" + this.$h.getLanguageValue(option.label) + "</li>";
                }
              }
            }
            value = value + "</ul>";
          }
          break;
        }
        case "radio": {
          const options = customField.config.options;
          if (current.custom[index] !== null) {
            const option = options.find((o) => {
              return o.value === current.custom[index];
            });
            if (option) {
              value = this.$h.getLanguageValue(option.label);
            }
          }
          break;
        }
        case "range": {
          const units = customField.config.unit;
          if (current.custom[index] !== null) {
            let amount = current.custom[index];
            let unit = "";
            for (const u in units) {
              if (u <= amount) {
                amount = amount * units[u].multiplier;
                unit = this.$h.getLanguageValue(units[u].label);
                value = amount + unit;
              } else {
                break;
              }
            }
          }
          break;
        }
        default: {
          value = current.custom[index];
        }
      }
      return value;
    },
  },
};
